module.exports = __webpack_public_path__ + "static/media/9.c9d63f0c.jpg";